import React, { useRef, useLayoutEffect, useMemo } from "react";
import CollapsibleWrapper from "../CollapsibleWrapper";
import StateBadge from "./StateBadge";
import { parseStateTag } from "../utils/parseStateTag";

const MsgToHumanContent = ({
  msg,
  messageId,
  initialExpanded,
  onToggle,
  renderMermaidContent,
  renderCopyButton,
  shouldCollapseByValue,
  styles,
}) => {
  // 解析思维状态徽章。流式过程中 msg.context 持续累积，标签闭合后即可被命中并渲染。
  const { state, cleanText } = useMemo(
    () => parseStateTag(msg.context || ""),
    [msg.context]
  );
  // 流式输出期间锁定 min-height 为已达到的最大高度，防止 Virtuoso 布局抖动
  const containerRef = useRef(null);
  const maxHeightRef = useRef(0);

  useLayoutEffect(() => {
    if (!msg.isStreaming) {
      maxHeightRef.current = 0;
      if (containerRef.current) containerRef.current.style.minHeight = '';
      return;
    }
    if (containerRef.current) {
      const h = containerRef.current.scrollHeight;
      if (h > maxHeightRef.current) {
        maxHeightRef.current = h;
        containerRef.current.style.minHeight = `${h}px`;
      }
    }
  });

  return (
    <div ref={containerRef} className={`message-content-wrapper ${styles.messageContentWrapper || ''}`}>
      {state ? <StateBadge state={state} /> : null}
      <CollapsibleWrapper
        messageId={messageId}
        collapsible={!msg.isStreaming && shouldCollapseByValue(cleanText)}
        initialExpanded={msg.isStreaming ? true : initialExpanded}
        onToggle={onToggle}
      >
        <div className={styles.expertMessage}>
          {renderMermaidContent(cleanText)}
        </div>
      </CollapsibleWrapper>
      {renderCopyButton(cleanText)}
    </div>
  );
};

export default React.memo(MsgToHumanContent);
